var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99121 3.03906L5.48242 3.49479L8.81413 9.30859L4.56934 10.4284L3.06217 9.16211L1.92285 9.50228L4.05827 13.1465L17.5527 9.59342C17.5544 9.59288 17.556 9.59234 17.5576 9.5918C17.8467 9.54056 18.1086 9.38918 18.2973 9.16419C18.486 8.9392 18.5894 8.65496 18.5895 8.36133C18.5895 8.02981 18.4578 7.71186 18.2234 7.47744C17.989 7.24302 17.671 7.11133 17.3395 7.11133C17.2307 7.11135 17.1224 7.12557 17.0173 7.15365V7.15202L12.6585 8.29948L6.99121 3.03906ZM2.75618 15.4447V17.1113H17.7562V15.4447H2.75618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.4214bbd9f77628bc91e33b11f7ddb36c.svg";
export { ForwardRef as ReactComponent };